import React, { Component } from 'react';
import { object, string } from 'prop-types';
import { inject, observer } from 'mobx-react';

import IntegrationDetailsView from './view';
import UpgradeModal from '../modals/upgrade';

class IntegrationDetails extends Component {
  static propTypes = {
    integrations: object.isRequired,
    type: string.isRequired,
    setup: object.isRequired,
    appConfig: object.isRequired,
    navigation: object.isRequired,
    biLogger: object.isRequired,
    view: object.isRequired,
    embeddedIntegrations: object.isRequired,
  };

  state = {
    config: undefined,
    articleHeight: 0,
  };

  receiveIframeHeightMessage(context) {
    context.handleIframeHeightMessage = (event) => {
      if (event.data.type === 'WINDOW-HEIGHT') {
        context.setState({
          articleHeight: event.data.payload.articleHeight
            ? event.data.payload.articleHeight
            : 1500,
        });
      }
    };
    return context.handleIframeHeightMessage;
  }

  setDetailedConfig() {
    const { integrations, type, setup } = this.props;

    return integrations.setDetailedConfig(type).then(async (config) => {
      config.preload && (await setup.preload(config.preload));
      this.setState({ config });
    });
  }

  componentDidMount() {
    window.addEventListener(
      'message',
      this.receiveIframeHeightMessage(this),
      false,
    );
    this.setDetailedConfig();
  }

  componentWillUnmount() {
    window.removeEventListener(
      'message',
      this.handleIframeHeightMessage,
      false,
    );
  }

  logIntegrationPageView = () => {
    const { type, biLogger } = this.props;
    biLogger.integrationPageView({ type });
  };

  openUpgradeModal = () => {
    const {
      view: { openModal },
      type,
      integrations: { getWidgetConfig },
    } = this.props;

    openModal(
      <UpgradeModal
        integrationType={type}
        integrationName={getWidgetConfig(type).title}
      />,
    );
  };

  handleActionClick = (handler, location) => {
    const {
      appConfig: { isPremium },
      biLogger,
      type,
      embeddedIntegrations,
    } = this.props;

    biLogger.integrationPageMainActionButtonClick({ location, type });
    isPremium || embeddedIntegrations.isWixSite
      ? this.props.setup.action(handler)
      : this.openUpgradeModal();
  };

  handleIntegrationMenuClick = (action) => {
    const { biLogger, type, setup } = this.props;

    const biData = { integrationType: type };
    if (action) {
      biLogger.integrationPageMenuOptionClick({
        ...biData,
        option: action.type,
      });
      setup.action(action.handler);
    } else {
      biLogger.integrationPageMenuClick(biData);
    }
  };

  handleBackClick = () => this.props.navigation.push('/');

  render() {
    const {
      setup: { isActionButtonVisible },
      appConfig: { staticsBaseUrl, experiments },
      view: { maxWidth },
      integrations: { getExtractedDetails },
      type,
    } = this.props;

    const { config, articleHeight } = this.state;

    const {
      appConfig: { locale },
    } = this.props;

    const {
      connectedTitle,
      disconnectedTitle,
      status,
      description,
      articleId,
      title,
      actions = [],
    } = getExtractedDetails(type) || {};

    const actionsReady = actions.length > 0;
    return (
      actionsReady && (
        <IntegrationDetailsView
          actions={actions}
          articleId={articleId}
          maxWidth={maxWidth}
          loading={!config || articleHeight === 0}
          connectedTitle={connectedTitle}
          disconnectedTitle={disconnectedTitle}
          experiments={experiments}
          locale={locale}
          onActionClick={this.handleActionClick}
          onIntegrationMenuClick={this.handleIntegrationMenuClick}
          onBackClick={this.handleBackClick}
          description={description}
          status={status}
          isActionButtonVisible={isActionButtonVisible}
          title={title}
          image={`${staticsBaseUrl}assets/integrations-images/${type}.png`}
          articleHeight={articleHeight}
          logIntegrationPageView={this.logIntegrationPageView}
        />
      )
    );
  }
}

export default inject(
  'navigation',
  'integrations',
  'setup',
  'appConfig',
  'biLogger',
  'view',
  'embeddedIntegrations',
)(observer(IntegrationDetails));
